import getFromCdn from '@anm/helpers/getFromCdn';
import { getFadeInAnimation } from '@anm/styles/helpers';
import styled from 'styled-components';

const Crown = styled.div`
  align-self: flex-start;
  margin-left: auto;
  width: 50px;
  height: 50px;
  background: url(${getFromCdn('images/icons/crown.svg')}) no-repeat 50% 50%;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 126;
  cursor: pointer;
  &:hover {
    z-index: 130;
    & + div {
      ${getFadeInAnimation()};
      animation-duration: 0.3s;
      z-index: 129;
    }
  }
`;

export default Crown;
